import React from 'react';
import { classNamesFunction } from '@fluentui/react';
var getClassNames = classNamesFunction();
export var CoherencePanelHeaderBase = function (props) {
    var headerId = props.headerId, titleText = props.titleText, panelProps = props.panelProps, onRenderHeader = props.onRenderHeader, theme = props.theme, styles = props.styles, isFooterInBody = props.isFooterInBody, hasNavigationHeader = props.hasNavigationHeader;
    var classNames = getClassNames(styles, {
        theme: theme,
        isFooterInBody: isFooterInBody,
        hasNavigationHeader: hasNavigationHeader
    });
    return onRenderHeader ? (React.createElement(React.Fragment, null, onRenderHeader(panelProps))) : (React.createElement("h1", { className: classNames.root, id: headerId }, titleText));
};
//# sourceMappingURL=CoherencePanelHeader.base.js.map